import barba from "@barba/core";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import toolbelt from "@upstatement/toolbelt";

// Lazy-load images
import "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset.js";
import "lazysizes/plugins/rias/ls.rias.js";

import { onDocumentReady } from "./utils/document-ready";
import { ClientComponentManager } from "./utils/client-component-manager";

import Link from "./components/link";
import ImageSizes from "./components/image-sizes";
import BrowserVars from "./components/browser-vars";
import Video from "./components/video";
import AdminToolbar from "./components/admin-toolbar";
import NavReveal from "./components/nav-reveal";
import FooterCircle from "./components/footer-circle";
import HoverCarousel from "./components/hover-carousel";
import ModalGallery from "./components/modal-gallery";
import AnnouncementBanner from "./components/announcement-banner";

onDocumentReady(() => {
  // Global components
  new BrowserVars();
  new FooterCircle();
  const navReveal = new NavReveal();

  // Template-specific components (contained within the barba container)
  new ClientComponentManager(Link, "a");
  new ClientComponentManager(ImageSizes, "img.lazyload");
  new ClientComponentManager(() => import("./components/grid"), ".js--grid");
  new ClientComponentManager(Video, ".js-video");
  new ClientComponentManager(
    () => import("./components/marquee"),
    "[data-marquee-container]",
  );
  new ClientComponentManager(HoverCarousel, ".js-gallery-carousel");
  new ClientComponentManager(
    () => import("./components/nav-theme-switcher"),
    "[data-homepage-topper]",
  );
  new ClientComponentManager(
    () => import("./components/connections-scroll-animation"),
    "[data-capabilities-description]",
  );
  new ClientComponentManager(
    () => import("./components/grow-fade"),
    "[data-fade-grow]",
  );
  new ClientComponentManager(
    () => import("./components/company-preview-tooltip"),
    "[data-company-preview]",
  );
  new ClientComponentManager(ModalGallery, ".js-modal-gallery");
  new ClientComponentManager(AnnouncementBanner, ".js-announcement-banner");
  new ClientComponentManager(
    () => import("./components/story-teases"),
    ".js-story-teases",
  );
  new ClientComponentManager(
    () => import("./components/big-headline-teases"),
    ".js-headline-teases",
  );

  const adminToolbarEl = document.querySelector(".js-admin-toolbar");
  if (adminToolbarEl) {
    new AdminToolbar(adminToolbarEl);
  }

  new ClientComponentManager(
    () => import("./components/hover-logo-tooltip.js"),
    ".js-logo-hover",
  );

  Alpine.plugin(toolbelt);
  Alpine.plugin(focus);
  Alpine.start();

  barba.init({
    // debug: import.meta.env.DEV,
    prevent: ({ el }) => el.classList && el.classList.contains("no-barba"),
    transitions: [
      {
        name: "default-transition",
        leave() {
          document.body.classList.add("is-transitioning");
        },
        enter({ next }) {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(next.html, "text/html");
          const newBody = newDocument.querySelector("body");
          const newHeader = newDocument.querySelector("header");
          window.scrollTo(0, this.newScrollY);

          if (newBody) {
            document.body.className = newBody.className;
            document.body.setAttribute(
              "data-theme",
              newBody.getAttribute("data-theme"),
            );
          }
          if (newHeader) {
            document.querySelector("header").className = newHeader.className;
          }

          // Re-init nav reveal to persist body classes
          navReveal.init();
        },
        after() {
          Alpine.start();
          window.requestAnimationFrame(() => {
            document.body.classList.remove("is-transitioning");
          });
        },
      },
    ],
  });
});
